import styled from 'styled-components';

export const ConversationPlanDetails = styled.ul`
  .conversation-additional-message {
    margin-left: 0;
  }

  @media (min-width: 768px) {
    .conversation-additional-message {
      margin-left: 12px;
    }
  }
`;
